// extracted by mini-css-extract-plugin
export default {"infoBox":"WXGqSpgwv2RZMg4lEvMw","idTitleBox":"uQAT05FnrHsXrlPYMaDN"};